import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-914d4832"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "right_container"
};
const _hoisted_2 = {
  class: "right_container_bom",
  id: "right_container_bom"
};
import SlideHeader from './slideHeader.vue';
import TaskList from './taskList.vue';
import roleHooks from '@/hooks/roleHooks';
import { useStore } from 'vuex';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const store = useStore();
    const {
      isShowRight,
      setIsShowRight
    } = roleHooks();
    const close = () => {
      setIsShowRight(false);
    };
    const outClick = () => {
      isShowRight.value && close();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SlideHeader, {
        onClose: close
      }), _createElementVNode("div", _hoisted_2, [_createVNode(TaskList)])]);
    };
  }
});